import * as Stripe from '@stripe/stripe-js';
import { deliveryOptionsPersist } from './gak-DeliveryOptions-persist';
import Utils from './utils';
import { updateWholeCart, ShoppingBasket_BindEvents, ShoppingBasket_ProceedToCheckout, showBasketError } from './gak-ShoppingBasket';
import { initTabs } from "./tabs"
import { debounceScript } from './Debounce.js';
import { loadPayPalButton } from './gak-PayPalButton';
import { getFormattedPrice, numberToCurrency } from './price-formatter';

var bpj: any;
var paymentRequest: any;

declare var DeliveryOptionsParms: any;
declare var EuroPrice_CurrencySymbol: any;
declare var EuroPrice_ConversionRate: any;
declare var basketConfig: any;
declare var ShoppingBasketParms: any;

export var basketParams: any;

const requestHeaders: HeadersInit = new Headers();
requestHeaders.set('Content-Type', 'application/json');

export function DeliveryOptions_Init(bpjValue: any) {
    bpj = bpjValue;
}

var pdojj: any;
var shoppingBasketContainer = "#shoppingBasketContent";
var deliveryOptionsContainer = "#divDeliveryOptionsContainer";
var divPaymentButtonsSelector = "#divBasketPaymentsButtonRow";

export function DeliveryOptions_BindEvents(isInit: boolean): void {
    var requestApplyVoucher =
        (debounceScript as any)(invokeApplyVoucher,
            500,
            { 'leading': false, 'trailing': true });
    /***** PARAMETERS SECTION ******/

    /* Delivery options JSON, containing the reduced necessary data for all delivery options available and the defaults (window.dojj) */
    showHideCheckoutBox();
    if (isInit) {
        if (bpj)
            basketParams = JSON.parse(Utils.atou(bpj));
    } else {
        var dojj = (<HTMLInputElement>document.getElementById("dojj"));

        if (dojj) {
            /* Delivery options JSON, containing the reduced necessary data for all delivery options available and the defaults */
            pdojj = JSON.parse(Utils.atou(dojj.value));
            /* This pdojj will contain:
                  pdojj.doj: Reduced Deliver Options data
                  pdojj.dodj: Reduced Default data
                  pdojj.pdj: Payment data containing the data necessary to display the payment buttons.
            */
        }
    }

    // No params whatsoever: return
    if (!basketParams && !pdojj) return;

    /***** END PARAMETERS SECTION ******/

    function triggerFinance() {
        //FinanceTab callback
        var financeTabInitializeData = (<any>window).financeTabInitializeData;
        if (typeof financeTabInitializeData === 'function' && financeTabInitializeData !== null) {
            financeTabInitializeData();
        }
    }
    //Defines callback used by FinanceTab
    var lastHasFinanceOptions: boolean;
    (<any>window).onHasFinanceOptions = function (hasFinanceOptions: boolean) {
        lastHasFinanceOptions = hasFinanceOptions;
        setCurrentDeliveryOptions();
    };

    // Perform processing that does not depend on having dojj & dodjj defined (eg. when there is nothing
    // in stock in the current basket)
    if (basketParams && basketParams.showLowStock) {
        var el = document.getElementById('delvStockIsLow');
        if (el) {
            el.classList.remove('hidden');
        }
    }

    // Region / Country changed.
    var delvRegId = (<HTMLInputElement>document.getElementById("DeliveryRegionId")!);
    var delvRegIdSelect = (<HTMLInputElement>document.getElementById("DeliveryRegionIdSelect")!);

    if (delvRegId) {
        delvRegId.addEventListener("change", handledelvRgIdChange);
    }

    if (delvRegIdSelect) {
        delvRegIdSelect.addEventListener("change", handledelvRgIdChange);
    }
    if (isInit === true) {
        if (!isBasketEmpty()) {
            var selDlvReg = delvRegId.value;

            DeliveryOptions_refresh(selDlvReg, deliveryOptionsPersist.getSelectedDeliveryTypeOption(), isInit !== true);
        }
    } else {
        if (basketParams && (basketParams.OutOfStock || basketParams.IsGiftVoucherOnlyOrder)) {
            setCurrentDeliveryOptions();
        }

        Voucher_BindEvents();
    }

    /*
        When clicking a DAY in the calendar:
        *	If currently selected Delivery Option is not available for that day,
            -	Select default Delivery Option for that day
        *	Update price from matrix [DeliveryOption][Day]
    */

    var speficDays = document.querySelectorAll(`${deliveryOptionsContainer} #specificDayTable td:not(.unavailable)`);

    if (speficDays) {
        speficDays.forEach(function (el, i) {
            el.addEventListener('click', function (e) {
                var internalDay = el!.getAttribute("data-day");
                var dtid = getSelectedDelvOptData().dtid;
                if (isSuperSaverDt(dtid)) {
                    // reset to default delivery type if current is super saved
                    // (maybe override again below)
                    dtid = getDefaultData().i;
                }
                var selPrice = getDelvOptPrice(dtid, internalDay);
                // Null, undefined, and 0 are falsey, but 0 is a valid price.
                if (!selPrice && selPrice !== 0) {
                    dtid = getDefaultDelvOptID(internalDay);
                    selPrice = getDelvOptPrice(dtid, internalDay);
                }

                setSelectedDelvOptData(dtid, internalDay, selPrice, true);
            });
        });
    }
    /*
        When clicking a DELIVERY OPTION item in the list:
        *	If currently selected Day is not available for that Delivery Option,
            -	Select default DAY for that Delivery Option
        *	Update price from matrix [DeliveryOption][Day]
    */
    const handleOptionBoxChangeEvent = new Event('handleOptionBoxChangeEvent');

    var optionBoxes = document.querySelectorAll(`${deliveryOptionsContainer} .deliveryOption .input-checkbox.optionBox`);
    if (optionBoxes) {
        optionBoxes.forEach(function (el, i) {
            el.addEventListener("change", handleOptionBoxChange);
            el.addEventListener("handleOptionBoxChangeEvent", handleOptionBoxChange);
        });
    }

    var calendarLink = document.getElementById("openCalendar");

    if (calendarLink)
        calendarLink.addEventListener("click", openCalendar);


    function handleOptionBoxChange(el: any) {
        var dtid = el.target!.getAttribute("data-dtid");
        var internalDay = getSelectedDelvOptData().day;
        var selPrice = getDelvOptPrice(dtid, internalDay);
        // Null, undefined, and 0 are falsey, but 0 is a valid price.
        if (!selPrice && selPrice !== 0) {
            internalDay = getDefaultDay(dtid);
            selPrice = getDelvOptPrice(dtid, internalDay);
        }

        setSelectedDelvOptData(dtid, internalDay, selPrice);
    }

    const handledelvRgIdChangeEvent = new Event('handledelvRgIdChangeEvent');

    function handledelvRgIdChange(el: any) {
        var delvRgIdVal = el.target.value
        updateWholeCart(delvRgIdVal);
    }

    // Trigger the selection.

    var selDlv = deliveryOptionsPersist.getSelectedDelivery();
    var defaultSelection = document.querySelector(`${deliveryOptionsContainer} .deliveryOption .input-checkbox.optionBox.default`);

    if (selDlv && selDlv.deliveryTypeID && selDlv.deliveryDate
        // The Price might change for the same delivery, depending on the value of the basket.
        && setSelectedDelvOptData(selDlv.deliveryTypeID, selDlv.deliveryDate, getDelvOptPrice(selDlv.deliveryTypeID, selDlv.deliveryDate))
    ) {
        // Nothing, already done.
    }
    else {
        // Trigger the default selection.
        if (defaultSelection) {
            defaultSelection.dispatchEvent(handleOptionBoxChangeEvent)
        }
    }

    function getCheckboxInputForDeliveryType(dtid: any): HTMLInputElement {
        return (<HTMLInputElement>document.querySelector(`${deliveryOptionsContainer} .deliveryOption .input-checkbox.optionBox[data-dtid='${dtid}']`));
    }

    function isSuperSaverDt(dtid: any) {
        var myDt = getDtById(dtid);
        if (!myDt || myDt.length <= 0) return null;

        return myDt[0].ss;
    }

    function isClickAndCollectDt(dtid: any) {
        var myDt = getDtById(dtid);
        if (!myDt || myDt.length <= 0) return null;

        return myDt[0].cc;
    }

    //function isAllDaysAvbleDt(dtid) {
    //    var myDt = getDtById(dtid);
    //    if (!myDt || myDt.length <= 0) return null;

    //    return myDt[0].ada;
    //}

    // *********** gak-DeliveryOptions internal use
    function getSelectedDelvOptData() {
        var deliveryTypeID = (<HTMLInputElement>document.getElementById("deliveryTypeID"))!;
        var deliveryDate = (<HTMLInputElement>document.getElementById("deliveryDate"))!;
        var selectedData = {
            dtid: deliveryTypeID.value, // Get dtid from the selected item in DT List.
            day: deliveryDate.value   // Get day from the selected day in Calendar.
        };

        return selectedData;
    }

    function setSelectedDelvOptData(dtid: any, internalDay: any, selPrice: any, fromCalendar: boolean = false) {
        // Update UI:
        //      Update DT List
        //          Remove all selections
        if ((!internalDay || !isSuperSaverDt(dtid)) && !fromCalendar) {
            internalDay = getDefaultDay(dtid);
        }

        var calendarSelector = `${deliveryOptionsContainer} #specificDayTable td`;
        var elemDay = document.querySelector(`${calendarSelector}[data-day='${internalDay}']`);
        var deliveryTypeID = (<HTMLInputElement>document.getElementById("deliveryTypeID"))!;
        var deliveryPrice = (<HTMLInputElement>document.getElementById("deliveryPrice"))!;
        var deliveryDate = (<HTMLInputElement>document.getElementById("deliveryDate"))!;
        
        if (elemDay?.classList.contains('unavailable') || selPrice == null) {
            var checkoutPrice = document.getElementById("checkoutDeliveryPrice");

            if (checkoutPrice && deliveryPrice)
                checkoutPrice.textContent = getFormattedPrice(deliveryPrice.value, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

            return false;
        }

        var elemDt = getCheckboxInputForDeliveryType(dtid);
        // Anything changed?

        var isDeliveryTypeChangedx = deliveryTypeID ? deliveryTypeID.value != dtid : false;
        var isDeliveryPriceChangedx = deliveryPrice ? parseFloat(deliveryPrice?.value || "-1") !== parseFloat(selPrice || 0) : false;
        var isDeliveryDateChangedx = deliveryDate ? deliveryDate.value != internalDay : false;
        var isNothingChanged = isInit || !(isDeliveryTypeChangedx || isDeliveryPriceChangedx || isDeliveryDateChangedx);

        if (isNothingChanged) {
            if (elemDt)
                elemDt.checked = true;
            return true;
        }

        document.querySelector(`${deliveryOptionsContainer} .deliveryOption`)?.classList.remove('highlightBlue');
        document.querySelector(`${deliveryOptionsContainer} .deliveryOption.chosenOption`)?.classList.remove('chosenOption');
        (<HTMLInputElement>document.querySelector(`${deliveryOptionsContainer} .deliveryOption .input-checkbox`)).setAttribute('checked', "false");
        //          Select current item
        elemDt.checked = true;
        elemDt.closest(".deliveryOption")?.classList.add('chosenOption');

        //          Current item's day-type prefix
        var myDtDays = getDaysForDtid(dtid, internalDay);
        // Don't prefix Super Saver (only super saver's input has a truthy value for 'daywindow' data value)
        // Plus always switch to first possible dates
        if (isSuperSaverDt(dtid)) {
            var superSaverinternalDay = myDtDays[0].d;
            if (superSaverinternalDay != internalDay) {
                setSelectedDelvOptData(dtid, superSaverinternalDay, selPrice);
                return; // Make sure we don't process the rest of the current function.
            }
        }

        var allDays = document.querySelectorAll(calendarSelector);

        if (allDays) {
            allDays.forEach(function (e, i) {
                e.classList.remove('chosenDay')
            });
        }

        if (elemDay)
            elemDay.classList.add('chosenDay');

        // When a day is selected, the prices displayed for all the items in DT List must be updated.
        var deliveryOptions = document.querySelectorAll(`${deliveryOptionsContainer} .deliveryOption`);

        deliveryOptions.forEach(function (el, i) {
            var myDtid = el.querySelector(".input-checkbox.optionBox")?.getAttribute("data-dtid");
            var myPrice = getDelvOptPrice(myDtid, internalDay);

            if (myPrice == null) {
                // Dt not available for the day. Get Default price.
                myPrice = getDelvOptPrice(myDtid, getDefaultDay(myDtid)); //"-";
            }

            // Format Price
            var formattedPrice = getFormattedPrice(myPrice, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

            var priceSpan = el.querySelector(".deliveryOptionPrice");

            if (priceSpan)
                priceSpan.textContent = formattedPrice;
        });

        // Update form data
        var deliveryTypeID = (<HTMLInputElement>document.getElementById("deliveryTypeID"));

        if (deliveryTypeID)
            deliveryTypeID.value = dtid;

        var deliveryDate = (<HTMLInputElement>document.getElementById("deliveryDate"));

        if (deliveryDate)
            deliveryDate.value = internalDay;

        // DeliveryLastDate. Is there a dayWindow?
        var dayWindow = elemDt.getAttribute("data-daywindow");
        var dayTo = null;

        if (dayWindow) {
            var daysToAdd = parseInt(dayWindow) - 1;
            var dayWindowArray = getDayWindowForDt(dtid, internalDay, daysToAdd);
            // Select the whole set of days in the window
            dayWindowArray?.forEach(function (x, index) {
                document.querySelector(`${calendarSelector}[data-day='${x}']`)?.classList.add('chosenDay');
            });
            dayTo = dayWindowArray?.slice(-1)[0];
        }
        var deliveryLastDate = (<HTMLInputElement>document.getElementById("deliveryLastDate"));

        if (deliveryLastDate)
            deliveryLastDate.value = dayTo;
        //// Note "|| -1"
        //var isDeliveryPriceChanged = parseFloat($('#deliveryPrice').val() || -1) !== parseFloat(selPrice || 0);
        var deliveryPrice = (<HTMLInputElement>document.getElementById("deliveryPrice"));

        if (deliveryPrice)
            deliveryPrice.value = selPrice;

        var checkoutPrice = document.getElementById("checkoutDeliveryPrice");

        if (checkoutPrice)
            checkoutPrice.textContent = getFormattedPrice(selPrice, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

        var checkoutSubtotalPrice = document.getElementById("checkoutSubtotalPrice");

        if (checkoutSubtotalPrice && basketParams.PriceTotalItems)
            checkoutSubtotalPrice.textContent = getFormattedPrice(basketParams.PriceTotalItems, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

        var giftVoucher = basketParams.GiftVouchers && basketParams.GiftVouchers.IsAnyApplied
            ? basketParams.GiftVouchers.DiscountValue : 0;
        var totalIncludingVATAndDelivery = document.getElementById("TotalIncludingVATAndDelivery");
        if (totalIncludingVATAndDelivery && basketParams.PriceTotalItems) {
            totalIncludingVATAndDelivery.textContent = getFormattedPrice(basketParams.PriceTotalItems + selPrice - giftVoucher, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);
        }

        // Keep selected values.
        deliveryOptionsPersist.saveSelectedDelivery(deliveryTypeID.value, deliveryDate.value);

        //      Update calendar header.
        document.querySelector(`${deliveryOptionsContainer} .deliveryCalendar #deliveryMonthName`)!.innerHTML = internaldateToMonthDisplayString(internalDay);

        //      Update Delivery Date field
        var newDeliveryHtml = isClickAndCollectDt(dtid) ? "Click & Collect from our Brighton store " : "Delivery ";
        var displayDay = elemDay ? elemDay.getAttribute("data-displayday") : "";
        if (dayTo == null) {
            newDeliveryHtml += "<strong>" + displayDay + "</strong>";
        }
        else {
            newDeliveryHtml += "between <strong>" + displayDay + " and " + internaldateToDisplayString(dayTo) + "</strong>";
        }
        var confirmationMessage = (elemDt.getAttribute("data-confirmationmsg") || '').trim();
        newDeliveryHtml += confirmationMessage ? ", " + confirmationMessage : ""; //Add confirmation message to the delivery text

        //Setting back previous title
        document.querySelectorAll(`${deliveryOptionsContainer} .deliveryOption .dtDescription`)?.forEach(function (e: any, i: any) {
            var title = e.getAttribute("data-title");
            e.textContent = title;
        });

        var elemDtDescription = elemDt.closest(".deliveryOption")?.querySelector(".dtDescription");

        if (elemDtDescription)
            elemDtDescription.innerHTML = newDeliveryHtml;

        updatePaymentButtons(dtid, internalDay);

        return true;
    }

    function updatePaymentButtons(dtid: any, internalDay: any) {
        if (lastHasFinanceOptions === undefined) {
            triggerFinance();
            return;
        }

        var divPaymentButtons = document.querySelector(divPaymentButtonsSelector)!;
        var data = {
            dtid: dtid,
            d: internalDay,
            dop: getDelvOpts(),
            finance: lastHasFinanceOptions || false
        };

        //We need to work out if payment buttons are rendered, without considering STRIPE
        var paymentButtonsRendered = divPaymentButtons.querySelectorAll(`.payment-buttons button[name='checkout']:not([data-payment-mehtod='STRIPE']),
                    .payment-buttons-finance,
                    #paypal-button-container`).length > 0;

        if (!paymentButtonsRendered) {
            fetch(basketConfig.paymentButtonsUrl, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: requestHeaders
            }).then((response) => {
                if (response.ok) {
                    return response.text();
                }
                showBasketError("Sorry but there was an error when loading payment buttons.");
            }).then(function (result) {
                if (result) {
                    divPaymentButtons.innerHTML = result;
                    PaymentData_BindEvents(result);

                    let parser = new DOMParser();
                    const doc = parser.parseFromString(result, 'text/html');

                    var netPayment = <HTMLInputElement>doc.getElementById("NetPayment")!;
                    var giftVoucherTotalRedeemed = <HTMLInputElement>doc.getElementById("GiftVoucherTotalRedeemed")!;
                    var hasPayPalCredit = <HTMLInputElement>doc.getElementById("HasPayPalCredit")!;
                    var hasPayPal = <HTMLInputElement>doc.getElementById("HasPayPal")!;
                    var highestDeposit = <HTMLInputElement>doc.getElementById("highestDeposit")!;
                    var highestDepositAmount = <HTMLInputElement>doc.getElementById("highestDepositAmount")!;
                    var shouldDisplayFinanceOptions = <HTMLInputElement>doc.getElementById("ShouldDisplayFinanceOptions")!;

                    DeliveryOptions_UpdatePdParams(parseFloat(netPayment.value), parseFloat(highestDeposit.value),
                        parseFloat(highestDepositAmount.value), parseFloat(giftVoucherTotalRedeemed.value),
                        hasPayPalCredit.value == 'True', hasPayPal.value == 'True', shouldDisplayFinanceOptions.value == 'True');

                    var buttons = document.querySelectorAll(`${divPaymentButtonsSelector} button`);

                    if (divPaymentButtons)
                        buttons.forEach(function (button) {
                            button.addEventListener('click', ShoppingBasket_ProceedToCheckout);
                        });
                }
            });
        }
        else {
            fetch(basketConfig.updatePaymentButtonsUrl, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: requestHeaders
            }).then((response) => {
                if (response.ok) {
                    return response.json();
                }
                showBasketError("Sorry but there was an error when loading payment buttons.");
            }).then(function (result: any) {
                DeliveryOptions_UpdatePdParams(result.NetPayment, result.HighestDeposit, result.highestDepositAmount,
                    result.GiftVoucherTotalRedeemed, result.HasPayPalCredit, result.HasPayPal, result.ShouldDisplayFinanceOptions);
                PaymentData_BindEvents(result);
            });
        }
    }

    function setCurrentDeliveryOptions() {
        var dtid = (<HTMLInputElement>document.getElementById('deliveryTypeID'));
        var dd = (<HTMLInputElement>document.getElementById('deliveryDate'));

        if (!dtid && !dd) return;

        deliveryOptionsPersist.saveSelectedDelivery(dtid.value, dd.value);
        updatePaymentButtons(dtid.value, dd.value);
    }

    function Voucher_BindEvents() {
        var voucherCodeInput = (<HTMLInputElement>document.getElementById("voucherCode"));
        var applyVoucherButton = document.getElementById("applyVoucherButton");
        var removeVoucherButton = document.querySelectorAll("button.removeVoucherButton");
        if (voucherCodeInput) {
            voucherCodeInput.addEventListener("keypress", handleVoucherCodeInputKeyPress);
        }
        if (applyVoucherButton && voucherCodeInput) {
            applyVoucherButton.addEventListener("click", handleApplyVoucherClick);
        }

        if (removeVoucherButton && removeVoucherButton.length > 0) {
            removeVoucherButton.forEach(function (button) {
                button.addEventListener("click", handleRemoveVoucherClick);
            });
        }

        function handleRemoveVoucherClick(e: any) {
            var voucherCode = e.currentTarget.getAttribute("data-code");
            var data = { voucherCode: voucherCode, remove: true };

            requestApplyVoucher(data);
        }

        function handleApplyVoucherClick(e: any) {
            e.preventDefault();

            var voucherCodeVal = voucherCodeInput.value;
            if (!voucherCodeVal || voucherCodeVal === "") return;

            var data = { voucherCode: voucherCodeInput.value, remove: false };

            requestApplyVoucher(data);
        }

        function handleVoucherCodeInputKeyPress(e: any) {
            if (e.keyCode === 13) {
                handleApplyVoucherClick(e);
            }
        }
    }

    function invokeApplyVoucher(data: any) {
        var applyVoucherButton = document.getElementById("applyVoucherButton");

        fetch(ShoppingBasketParms.ApplyVoucherURL, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: requestHeaders
        }).then(response => response.text())
            .then(function (result) {
                var basket = document.querySelector(shoppingBasketContainer)!;
                basket.innerHTML = result;

                if (applyVoucherButton) {
                    var newButton = applyVoucherButton.cloneNode(true);
                    if (applyVoucherButton.parentNode)
                        applyVoucherButton.parentNode.replaceChild(newButton, applyVoucherButton);
                }
                var bpj = (<HTMLInputElement>document.getElementById("bpj")!);
                if (bpj)
                    DeliveryOptions_Init(bpj.value);

                ShoppingBasket_BindEvents();
                DeliveryOptions_BindEvents(true);

                var voucherError = <HTMLInputElement>document.getElementById("voucherError");
                var voucherErrorContainer = document.getElementById("voucherErrorContainer")!;
                let voucherInput = document.querySelector("#gift-voucher-input .floating-button");

                if (voucherError) {
                    voucherErrorContainer.innerHTML = `${voucherError.value}`;
                    if (voucherInput) voucherInput.classList.add('is-invalid');
                }
                else {
                    voucherErrorContainer.hidden = true;
                    if (voucherInput) voucherInput.classList.remove('is-invalid');
                }
            });
    }

    function PaymentData_BindEvents(result: any) {
        if (result.Buttons) {
            var buttonsSelector = document.querySelectorAll(".btn-item:not(.stripe-button-container)");
            var paymentButtonsContainer = document.querySelector(divPaymentButtonsSelector)!;

            if (buttonsSelector)
                buttonsSelector.forEach(function (button) {
                    button.remove();
                });

            const financeText = document.getElementById("financeOptionsText");

            if (financeText) {
                if (result.HasFinanceOptions) {
                    financeText.removeAttribute("hidden");
                } else {
                    financeText.setAttribute("hidden", "hidden");
                }
            }

            var buttonsContainer = document.getElementsByClassName("payment-buttons")?.item(0);

            if (buttonsContainer) {
                let hasPayPal = false;
                result.Buttons.forEach(function (el: any) {
                    const btnData = el;
                    const amazonPayStyle = btnData.value == "amz" ? "margin-top: 8px" : "";
                    const btnContent = btnData.displayImg === ""
                        ? btnData.displayText
                        : `<img style="${amazonPayStyle}" src="${btnData.displayImg.replace("~", "")}"/>${btnData.displayText}`;

                    if (btnData.value != 'stripe') {
                        if (btnData.value === 'pp') {
                            hasPayPal = true;
                        } else {
                            const button = renderButton(!btnData.isFinance);
                            const container = btnData.isFinance ? getFinanceContainer()! : buttonsContainer!

                            addButtonToContainer(container, button);
                        }
                    }

                    function getFinanceContainer() {
                        if (!paymentButtonsContainer.querySelector(".payment-buttons-finance")) {
                            const paymentButtonsFinance = document.createElement("div");

                            paymentButtonsFinance.classList.add("payment-buttons-finance");
                            paymentButtonsFinance.setAttribute("data-columns", "");
                            paymentButtonsContainer.appendChild(paymentButtonsFinance);
                        }

                        return document.getElementsByClassName("payment-buttons-finance")?.item(0);
                    }

                    function renderButton(isFullWidth: boolean = true) {
                        return `
                            <button type='submit' name='checkout' value='${btnData.value}'
                                    data-payment-mehtod='${btnData.id}'
                                    class='btn ${isFullWidth ? "btn-fullwidth" : ""} btn-item btn-payment-type checkout checkoutButton ${btnData.cssClass}' role='button'>
                                ${btnContent}
                            </button>`;
                    }

                    function addButtonToContainer(container: Element, button: string) {
                        container.innerHTML += button;
                    }
                });

                const payPalButtonContainer = document.getElementById("paypal-button-container");
                let ppMessage = document.querySelector("[data-pp-message]");

                if (!hasPayPal && payPalButtonContainer?.hasChildNodes()) {
                    payPalButtonContainer!.innerHTML = '';

                    if (ppMessage) {
                        ppMessage.remove();
                    }
                } else if (hasPayPal && (!payPalButtonContainer || !payPalButtonContainer.hasChildNodes())) {
                    setPayPalButton(result.ShouldDisplayFinanceOptions);

                    if (!ppMessage && payPalButtonContainer) {
                        ppMessage = document.createElement("div");
                        ppMessage.setAttribute("data-pp-message", "");
                        ppMessage.setAttribute("data-pp-amount", result.NetPayment);
                        ppMessage.setAttribute("data-pp-style-text-size", "11");

                        payPalButtonContainer.insertAdjacentElement("afterend", ppMessage)
                    }
                }
            }
        }

        var buttons = document.querySelectorAll("#divBasketPaymentsButtonRow button");

        if (buttons) {
            buttons.forEach(function (btn) {
                btn.addEventListener('click', ShoppingBasket_ProceedToCheckout);
            });
        }

        var updateForm = <HTMLFormElement>document.getElementById("UpdateStockForm");

        if (updateForm) {
            var oldBtoajDelvOptParams = (<HTMLInputElement>document.querySelector("input[name=btoajDelvOptParams]"));
            if (oldBtoajDelvOptParams)
                oldBtoajDelvOptParams.remove();

            var btoajDelvOptParams = document.createElement("input");
            btoajDelvOptParams.setAttribute("name", "btoajDelvOptParams");
            btoajDelvOptParams.setAttribute("hidden", "hidden");

            btoajDelvOptParams.value = getDelvOptsSerialised();

            updateForm.append(btoajDelvOptParams);

        }

        DeliveryOptionsButtons_BindEvents();
    }

    function DeliveryOptionsButtons_BindEvents() {
        // Show warning.
        var ccwarning = document.querySelectorAll(`${deliveryOptionsContainer} .ccwarning`);
        var ccEarliestwarning = document.querySelectorAll(`${shoppingBasketContainer} .basket-item-stock.ccEarliestwarning`);

        if (getDelvOpts().IsClickAndCollectShowWarning && isUKMainland()) {
            // Reset Delivered / Click & Collect buttons.
            deliveryOptionsPersist.resetSelectedDeliveryTypeOption();

            // Display warning
            if (ccwarning) {
                ccwarning.forEach(function (el, i) {
                    el.classList.remove('hidden');
                });
            }

            // Hide Earliest c&c warning from basket items.
            if (ccEarliestwarning) {
                ccEarliestwarning.forEach(function (el, i) {
                    el.classList.add('hidden');
                });
            }
        }
        else {
            // Hide warning
            if (ccwarning) {
                ccwarning.forEach(function (el, i) {
                    el.classList.add('hidden');
                });
            }
            // Show Earliest c&c warning from basket items.
            if (ccEarliestwarning) {
                ccEarliestwarning.forEach(function (el, i) {
                    el.classList.remove('hidden');
                });
            }
        }

        // Show buttons
        var devOptBtns = document.querySelectorAll(`${deliveryOptionsContainer} a.devOptsLinks`);

        if (devOptBtns) {
            devOptBtns.forEach(function (el) {
                el.addEventListener('click', handleDeliveryOptionClicked);
            });
        }
    }

    function handleDeliveryOptionClicked(el: any) {
        var curBtnName = el.target.getAttribute('name');
        if (deliveryOptionsPersist.getSelectedDeliveryTypeOption() !== curBtnName) {
            deliveryOptionsPersist.saveSelectedDeliveryTypeOption(curBtnName);

            DeliveryOptions_refresh(selDlvReg, deliveryOptionsPersist.getSelectedDeliveryTypeOption(), false);
        }
    }

    DeliveryOptionsButtons_BindEvents();
    // *********** gak-DeliveryOptions internal use
}

export function SetDojj(doj: string) {
    if (doj) {
        pdojj = JSON.parse(Utils.atou(doj));
    }
}

export function DeliveryOptions_refresh(deliveryRegionId: any, deliveryOptionTypeSelected: any, isResetDelivery: boolean) {
    var body = {
        deliveryRegionId: deliveryRegionId,
        deliveryOptionType: deliveryOptionTypeSelected,
        basketParams: basketParams
    };

    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    fetch(DeliveryOptionsParms.IndexDeliveryOptionsURL, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: requestHeaders
    }).then((response) => {
        if (response.ok) {
            return response.text();
        }
        showBasketError("Sorry but there was an error: Invalid delivery options");
    }).then(function (data) {
        if (data) {
            var divContainer = document.querySelector(deliveryOptionsContainer)!;
            if (isResetDelivery) deliveryOptionsPersist.resetSelectedDelivery();
            if (divContainer) divContainer.innerHTML = data;

            DeliveryOptions_BindEvents(false);
            initTabs();
        }
    });
}

// JSON Data. Get the Price for a delivery option and a day. Returns NULL if not found.
export function getDelvOptPrice(dtid: any, internalDay: any) {
    var myDay = getDaysForDtid(dtid, internalDay);
    if (!myDay || myDay.length <= 0) return null;

    var myPrice = myDay[0].p;

    return myPrice;
}
// JSON Data. Get the default (cheapest) delivery option available for a day.
export function getDefaultDelvOptID(internalDay: any) {
    var myDts = getDelvOptsData().map(function (x: any) {
        return { xID: x.i, xPrice: (getDelvOptPrice(x.i, internalDay)), isSuperSaver: x.ss };
    });
    var availableDts = myDts.filter(function (x: any) {
        return x.xPrice !== null;
    });

    // Get Delv opt with min value
    var minPriceDt = availableDts.reduce(function (res: any, obj: any) {
        return (obj.xPrice < res.xPrice) ? obj : res;
    });
    if (!minPriceDt) return null;

    return minPriceDt.xID;
}
// JSON Data. Get the default (first) day available for a delivery option.
function getDefaultDay(dtid: any) {
    var myDays = getDaysForDtid(dtid, null);

    if (!myDays || myDays.length <= 0) return null;

    // Get the first available
    var minDay = myDays[0].d;
    return minDay;
}

// JSON Data. Returns the day available in the future: from the base internalDay + daysAdd forward.
function getDayWindowForDt(dtid: any, internalDay: boolean, daysAdd: number) {
    // Get the index of the base internalDay
    var myDay = getDaysForDtid(dtid, internalDay);
    if (!myDay || myDay.length <= 0) return null;

    var myDtDays = getDaysForDtid(dtid, null);
    var dayIndex = myDtDays.indexOf(myDay[0]);
    if (dayIndex < 0) return null;
    var dayWindow = [];
    for (var i = dayIndex; i <= dayIndex + daysAdd; i++) {
        dayWindow.push(myDtDays[i].d);
    }
    return dayWindow;
}

function getDaysForDtid(dtid: any, internalDay: any) {
    var myDt = getDtById(dtid);

    if (!myDt || myDt.length <= 0) return null;

    var myDtDays = myDt[0].dpl;

    if (internalDay == null) return myDtDays;

    // Ability to filter by day.
    var myDay = myDtDays.filter(function (x: any, i: any) {
        return (x.d == internalDay);
    });
    return myDay;
}

function getDtById(dtid: any) {
    var myDt = getDelvOptsData().filter(function (x: any, i: any) {
        return (x.i == dtid);
    });

    return myDt;
}

export function getDelvOptsData() {
    return !pdojj ? [] : pdojj.doj; // Array expected
}
export function getDefaultData() {
    return !pdojj ? {} : pdojj.dod; // Object expected
}
function getDelvOpts() {
    return (pdojj || {}); // Object expected
}
function getDelvOptsSerialised() {
    return Utils.utoa(JSON.stringify(getDelvOpts()));
}

function internaldateToDisplayString(internalDay: any) {
    var options = {
        weekday: "short", year: "numeric", month: "short",
        day: "numeric"
    };
    return internalDayToDisplayStringOptions(internalDay, options);
}
function internaldateToMonthDisplayString(internalDay: any) {
    var options = {
        month: "long"
    };
    return internalDayToDisplayStringOptions(internalDay, options);
}
function internalDayToDisplayStringOptions(internalDay: any, options: any) {
    // Parse date dd/MM/yyyy (LogicConstants.Formats.DateTime.DeliveryDate)
    if (internalDay) {
        var dateSplit = internalDay.split("/");
        var myDate = new Date(dateSplit[2], parseInt(dateSplit[1]) - 1, dateSplit[0]);
        // Convert to short string
        return myDate.toLocaleDateString("en-GB", options);
    }

    return "";
}

// Update Payment data.
function DeliveryOptions_UpdatePdParams(netPayment: number,
    highestDeposit: number,
    highestDepositAmount: number,
    gvTotalRedeemed: number,
    hasPayPalCreditPayment: boolean,
    hasPayPal: boolean,
    shouldDisplayFinanceOptions: boolean) {
    // New payment value
    if (!isNaN(netPayment)) {
        var total = document.getElementById("TotalIncludingVATAndDelivery");

        if (total)
            total.innerHTML = numberToCurrency(netPayment, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

        var voucherApplied = document.querySelectorAll('.giftVoucherValueApplied');

        if (voucherApplied)
            voucherApplied.forEach(function (e: any) {
                e.textContent = numberToCurrency(gvTotalRedeemed, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate)
            });

        var isNoNetPayment = netPayment <= 0;

        if (highestDeposit > 0 && highestDepositAmount > 0) {
            var depositPlaceholder = document.querySelector('#divDeliveryOptionsContainer .depositPlaceholder');
            if (depositPlaceholder) {
                depositPlaceholder.innerHTML = `${highestDeposit} % deposit required today: 
                            <span class="price"> ${numberToCurrency(highestDepositAmount, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate)}</span>
                            <br/ > Balance payable upon collection: <span class="price"> ${numberToCurrency(netPayment - highestDepositAmount, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate)} </span>`
                depositPlaceholder.classList.remove('hidden');
            }
        }

        var stripePaymentRequestBtn = document.getElementById("paymentRequestButton");

        if (stripePaymentRequestBtn && !isNoNetPayment) {
            setStripePaymentRequestButton(netPayment);
        }
    }

    // Paypal Credit
    var ppDiv = document.getElementById('paypal-credit-section-contents');
    if (ppDiv) {
        if (hasPayPalCreditPayment || hasPayPal) {
            ppDiv.classList.remove('hidden');
        }
        else {
            ppDiv.classList.remove('hidden');
        }
    }

    const payPalButtonContainer = document.getElementById("paypal-button-container")!;
    if (hasPayPal && payPalButtonContainer.children.length == 0) {
        setPayPalButton(false);
    }

    //do we need express checkout section
    var h1text = document.getElementById("h1text");
    if (h1text) {
        h1text.innerHTML = h1text.innerHTML + '**1';
    }

    var expresscheckout = document.querySelector("#divBasketPaymentsButtonRow .express-checkout");
    var othercheckout = document.querySelector("#divBasketPaymentsButtonRow .other-checkout h2");
    var expressbuttonsContainer = document.getElementById("paymentRequestButton");
    var paypalContainer = document.getElementById("paypal-button-container");
    if (!hasPayPal && expresscheckout && othercheckout && expressbuttonsContainer && expressbuttonsContainer.innerHTML == '' && 
    paypalContainer && paypalContainer.innerHTML == '') {
        expresscheckout.classList.remove('show');
        othercheckout.classList.remove('show');
    }
}

function setPayPalButton(enablePayLater: boolean) {
    loadPayPalButton({
        clientId: ShoppingBasketParms.PaylPalClientId,
        currency: "GBP",
        enableFunding: "",
        components: "messages,buttons"
    });
}

function isUKMainland() {
    var deliveryRegionId = (<HTMLInputElement>document.getElementById("DeliveryRegionId")!).value;
    return deliveryRegionId && deliveryRegionId == (<any>window).ukMainlandRegionId;
}

function getAmountInCents(amount: any) {
    return parseInt((amount * 100).toFixed());
}

function getPlainText(text: string) {
    return text.replace(/(\r\n|\n|\r)|(\s\s+)/gm, "");
}

function getStripeShippingOptions(selPrice: any) {
    if (document.querySelector(`.chosenOption>input`)?.hasAttribute("data-dtid")) {
        return [
            {
                id: document.querySelector(".chosenOption>input")!.getAttribute("data-dtid"),
                label: getPlainText(document.querySelector(".chosenOption .dtDescription")!.getAttribute("data-title")!),
                detail: getPlainText(document.querySelector(".chosenOption .dtDescription")!.textContent!),
                amount: getAmountInCents(selPrice)
            }];
    } else {
        return [{
            id: "oos",
            label: document.querySelector(".delivery-out-of-stock > #outOfStockLabel") != null ? getPlainText(document.querySelector(".delivery-out-of-stock > #outOfStockLabel")!.textContent!) : "Delivery not available",
            detail: document.querySelector(".delivery-out-of-stock > #outOfStockDetail") != null ? getPlainText(document.querySelector(".delivery-out-of-stock > #outOfStockDetail")!.textContent!) : "Delivery not available",
            amount: getAmountInCents(selPrice)
        }];
    }
}

function setStripePaymentRequestButton(amount: any) {
    if (isNaN(amount)) {
        return;
    }

    var stripeKey = (<HTMLInputElement>document.getElementById('StripePublishableKey'))!.value;
    var selPrice = (<HTMLInputElement>document.getElementById('deliveryPrice'))!.value;
    //var shippingOptions = getStripeShippingOptions(selPrice);
    Stripe.loadStripe(stripeKey).then(function (stripe: any) {
        var paymentRequestButton = document.getElementById("paymentRequestButton");
        if (paymentRequestButton?.childElementCount == 0) {
            paymentRequest = stripe.paymentRequest(getPaymentRequestOptions(amount, getStripeShippingOptions(selPrice)));

            var elements = stripe.elements();
            var prButton = elements.create('paymentRequestButton', {
                paymentRequest: paymentRequest,
            });

            // Check the availability of the Payment Request API first.
            paymentRequest.canMakePayment().then(function (result: any) {
                if (result) {
                    prButton.mount('#paymentRequestButton');
                    let stripeButtonContainer = document.querySelector(".stripe-button-container.loading");
                    if (stripeButtonContainer) stripeButtonContainer.classList.remove('loading');
                } else {
                    var stripeButtonContainer = document.getElementsByClassName("stripe-button-container")?.item(0);
                    if (stripeButtonContainer) {
                        stripeButtonContainer.setAttribute("hidden", "hidden");
                    }
                }

                paymentRequest.on('paymentmethod', function (ev: any) {
                    var updateForm = <HTMLFormElement>document.getElementById('UpdateStockForm');

                    function submitForm() {
                        var dojj = (<HTMLInputElement>document.getElementById("dojj"))!;

                        var url = updateForm.getAttribute('action')!;

                        var data = new FormData(updateForm);

                        data.set("btoajDelvOptParams", dojj.value);
                        data.set("checkout", "stripe");
                        data.set("IsDigitalWallet", "true");

                        fetch(url, {
                            method: 'POST',
                            body: data
                        }).then((response) => {
                            if (response.ok) {
                                isPaymentRequested = true;

                                fetch(`/checkout/createPaymentIntent?paymentmethodId=${ev.paymentMethod.id}&recipient=${ev.shippingAddress.recipient}&customerEmail=${ev.payerEmail}&payerPhone==${ev.payerPhone}`).then(function (response) {
                                    return response.json();
                                }).then(function (createPaymentIntentResponse) {
                                    stripe.confirmCardPayment(
                                        createPaymentIntentResponse.ClientSecret,
                                        {
                                            payment_method: ev.paymentMethod.id,
                                            shipping: {
                                                address: {
                                                    city: ev.shippingAddress.city,
                                                    country: ev.shippingAddress.country,
                                                    line1: ev.shippingAddress.addressLine[0],
                                                    line2: ev.shippingAddress.addressLine.length == 2 ? ev.shippingAddress.addressLine[1] : null,
                                                    postal_code: ev.shippingAddress.postalCode,
                                                    state: ev.shippingAddress.region
                                                },
                                                name: ev.shippingAddress.recipient,
                                                phone: ev.payerPhone
                                            }
                                        },
                                        { handleActions: false }
                                    ).then(function (confirmResult: any) {
                                        LogStripeResponse(confirmResult, false);
                                        if (confirmResult.error) {
                                            alert(confirmResult.error);
                                            ev.complete('fail');
                                        } else {
                                            // Report to the browser that the confirmation was successful, prompting
                                            // it to close the browser payment method collection interface.
                                            ev.complete('success');
                                            // Check if the PaymentIntent requires any actions and if so let Stripe.js
                                            // handle the flow. If using an API version older than "2019-02-11"
                                            // instead check for: `paymentIntent.status === "requires_source_action"`.
                                            if (confirmResult.paymentIntent.status === "requires_action") {
                                                // Let Stripe.js handle the rest of the payment flow.
                                                stripe.confirmCardPayment(createPaymentIntentResponse.ClientSecret).then(function (result: any) {
                                                    LogStripeResponse(result, true);
                                                    if (result.error) {
                                                        alert(result.error);
                                                    } else {
                                                        ProcessDigitalWalletPayment(ev, confirmResult, createPaymentIntentResponse);
                                                    }
                                                });
                                            } else {
                                                ProcessDigitalWalletPayment(ev, confirmResult, createPaymentIntentResponse);
                                            }
                                        }
                                    });
                                });
                            }
                        });
                    }

                    if (!isPaymentRequested)
                        submitForm();

                    function LogStripeResponse(confirmResult: any, is3DSResult: boolean) {
                        var data = {
                            is3DSResult: is3DSResult,
                            confirmResult: JSON.stringify(confirmResult)
                        };

                        fetch('Checkout/LogStripeResponse', {
                            method: 'POST',
                            body: JSON.stringify(data),
                            headers: requestHeaders
                        });
                    }

                    function ProcessDigitalWalletPayment(ev: any, confirmResult: any, createPaymentIntentResponse: any) {
                        var data = {
                            shippingAddress: ev.shippingAddress,
                            paymentIntentId: confirmResult.paymentIntent.id,
                            customerEmail: ev.payerEmail,
                            clientSecret: createPaymentIntentResponse.ClientSecret,
                            customerPhone: ev.payerPhone
                        };
                        fetch('Checkout/ValidateAddress',
                            {
                                method: 'POST',
                                body: JSON.stringify(data),
                                headers: requestHeaders
                            }).then(response => response.json())
                            .then(function (result) {
                                if (result.success && result.redirectUrl !== "") {
                                    window.location = result.redirectUrl;
                                }
                                else if (result.redirectUrl !== "") {
                                    window.location = result.redirectUrl;
                                }
                            });
                    }
                });

                paymentRequest.on('shippingaddresschange', function (ev: any) {
                    var delvRegId = (<HTMLInputElement>document.getElementById("DeliveryRegionId"))!.value;
                    var deliveryRegionMap: any = JSON.parse((<HTMLInputElement>document.getElementById("deliveryRegionMap"))!.value);
                    if (ev.shippingAddress.country !== deliveryRegionMap[delvRegId]) {
                        ev.updateWith({ status: 'invalid_shipping_address' });
                    } else if (ev.shippingAddress.country == 'GB') {
                        var data = {
                            shippingAddress: ev.shippingAddress,
                            customerEmail: ev.payerEmail,
                            customerPhone: ev.payerPhone
                        };

                        fetch('Checkout/ValidatePostCodeAndRegion',
                            {
                                method: 'POST',
                                body: JSON.stringify(data),
                                headers: requestHeaders
                            }).then(response => response.json())
                            .then(function (result) {
                                if (result.success && result.redirectUrl !== "") {
                                    ev.updateWith({ status: 'success', shippingOptions: getStripeShippingOptions(selPrice) });
                                }
                                else {
                                    ev.updateWith({ status: 'invalid_shipping_address' });
                                }
                            });
                    }
                });
            });
            
        }
        else {
            paymentRequest.update(getPaymentRequestUpdateOptions(amount, getStripeShippingOptions(selPrice)));
        }

        var isPaymentRequested = false;

        function getPaymentRequestOptions(amount: number, shippingOptions: any) {
            return {
                country: 'GB',
                currency: 'gbp',
                total: {
                    label: 'Total including VAT',
                    amount: getAmountInCents(amount),
                },
                requestPayerName: true,
                requestPayerEmail: true,
                requestShipping: true,
                requestPayerPhone: true,
                shippingOptions: shippingOptions
            }
        }

        function getPaymentRequestUpdateOptions(amount: number, shippingOptions: any) {
            return {
                total: {
                    label: 'Total including VAT',
                    amount: getAmountInCents(amount),
                },
                shippingOptions: shippingOptions,
            }
        }


    });
}

function openCalendar(el: any) {
    el.target.style.display = "none";

    var calendar = document.getElementsByClassName("deliveryCalendar");
    if (calendar && calendar.item(0)) {
        calendar.item(0)!.removeAttribute("hidden");
    }
}

function showHideCheckoutBox() {
    var basketEmpty = document.getElementById("basketEmptyText");
    var checkoutBox = document.getElementsByClassName("checkout-box-container")?.item(0);
    if (checkoutBox) {
        if (basketEmpty) {
            checkoutBox.setAttribute("hidden", "hidden");
        } else {
            checkoutBox.removeAttribute("hidden");
        }
    }
}

function isBasketEmpty() {
    var basketEmptyEl = document.getElementById("basketEmptyText");

    return basketEmptyEl != null && basketEmptyEl != undefined;
}
